import { j as e } from "../../../_virtual/jsx-runtime.js";
import { cn as s } from "../../../lib/utils.js";
import h from "../Icon/index.js";
import u from "../SkeletonWrapper/index.js";
const C = ({
  title: t,
  subtitle: r,
  children: a,
  className: l,
  titleClassName: c,
  subtitleClassName: n,
  leftIconProps: i,
  size: m,
  leftContentClassName: x,
  rightContentClassName: o,
  isLoading: d
}) => {
  const p = m ? `text-${m}` : "text-md", f = s("font-medium mb-0", p, c), j = s(
    "text-sm text-neteera-teal-600 mb-0 mt-2",
    n
  );
  return /* @__PURE__ */ e.jsx(u, { isLoading: d, full: !0, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: s(
        "card-header flex items-center justify-between gap-4 flex-wrap",
        l
      ),
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: x, children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flex gap-2", children: [
            /* @__PURE__ */ e.jsx(h, { ...i }),
            t && /* @__PURE__ */ e.jsx("p", { className: f, children: t })
          ] }),
          r && /* @__PURE__ */ e.jsx("p", { className: j, children: r })
        ] }),
        a && /* @__PURE__ */ e.jsx(
          "div",
          {
            className: s(
              "right-content flex items-center",
              o
            ),
            children: a
          }
        )
      ]
    }
  ) });
};
export {
  C as default
};
